import React from 'react';
import classNames from 'classnames';
import $ from '../../../../offline/jquery.min.js';
import PropTypes from 'prop-types';

import { FormContext } from '../../../Context/FormContext';
import ConfigService from "../../../Services/api/Config";

import './style.scss';

class InputWrapper extends React.PureComponent {
  static contextType = FormContext;

  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
  }

  render() {
    const { label, children, error, className, required, labelhtml, notShowErrors } = this.props;
    const isSubmitted = this.context ? this.context.isSubmitted : false;

    const showError = Boolean(error) && Boolean(isSubmitted);

    if (this.wrapperRef && this.wrapperRef.current) {
      if (showError) {
        $(this.wrapperRef.current).find("input:not([type='radio']):not([type='checkbox']):not([type='file']), textarea, canvas").css('border-color', ConfigService.getColor('errorColor'));
        $(this.wrapperRef.current).find(".css-yk16xz-control, .css-1pahdxg-control, .css-1fhf3k1-control, .DropZone").css('border-color', ConfigService.getColor('errorColor'));
      }
      else {
        $(this.wrapperRef.current).find("input:not([type='radio']):not([type='checkbox']):not([type='file']), textarea, canvas").css('border-color', ConfigService.getColor('tertiaryColor'));
        $(this.wrapperRef.current).find(".css-yk16xz-control, .css-1pahdxg-control, .css-1fhf3k1-control, .DropZone").css('border-color', ConfigService.getColor('tertiaryColor'));
      }
    }

    return (
      <div
        className={ classNames(className, 'InputWrapper', {
          InputWrapper_Error: showError,
        }) }
        ref={ this.wrapperRef }
      >
        { label &&
          <div className='InputWrapper-Label'>
            {label}
            { required &&
              <span className='InputWrapper-Label-Required' style={ { color: ConfigService.getColor('errorColor') } }>*</span>
            }
          </div>
        }
        { labelhtml &&
          <div className='InputWrapper-Label'>
            <div dangerouslySetInnerHTML={{__html: labelhtml}}>
            </div>
          </div>
        }
        <div className='InputWrapper-Content'>
          { children }
        </div>
        { (error && isSubmitted && !notShowErrors) && (
          <div className='InputWrapper-Error' style={ { color: ConfigService.getColor('errorColor') } }>
            { error }
          </div>
        ) }
      </div>
    );
  }
}


InputWrapper.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  error: PropTypes.string,
  className: PropTypes.string,
  notShowErrors: PropTypes.bool,
  required: PropTypes.bool,
  isSubmitted: PropTypes.bool,
};

export default InputWrapper;
